import { render, staticRenderFns } from "./Discus.vue?vue&type=template&id=0d07cf49&lang=pug&"
import script from "./Discus.vue?vue&type=script&lang=ts&"
export * from "./Discus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports